import {  useEffect, useMemo, useState } from 'react';

// material-ui
import { Theme } from '@mui/material/styles';
import { Box,  Button,  IconButton, useMediaQuery } from '@mui/material';

// project-imports
// import Search from './Search';
import Message from './Message';
import Profile from './Profile';
import Localization from './Localization';
import Notification from './Notification';
import MobileSection from './MobileSection';
// import MegaMenuSection from './MegaMenuSection';

import useConfig from 'hooks/useConfig';
import DrawerHeader from 'layout/MainLayout/Drawer/DrawerHeader';
// import Logo from 'components/logo';

// type
import { LAYOUT_CONST } from 'types/config';
import LogoMain from 'components/logo/LogoMain';
import {  Android, Apple, RefreshCircle } from 'iconsax-react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const { i18n, menuOrientation } = useConfig();
const [isUpdateAvailable, setIsUpdateAvailable] = useState(false);
  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const localization = useMemo(() => <Localization />, [i18n]);
  console.warn(localization);

const webVersion = useSelector((state: RootState) => state.webVersion.version);

useEffect(() => {
  if(webVersion && localStorage.getItem('local_version') !== webVersion){
    setIsUpdateAvailable(true);
  }else{
    setIsUpdateAvailable(false);
  }
console.log(webVersion);

}, [webVersion]);
  // const isUpdateAvailable = parseFloat(localStorage.getItem('local_version')?? '0')< parseFloat(localStorage.getItem('server_version')?? '0');
  // const megaMenu = useMemo(() => <MegaMenuSection />, []);

  return (
    <>
      {menuOrientation === LAYOUT_CONST.HORIZONTAL_LAYOUT && !downLG && <DrawerHeader open={true} />}
        {!downLG && <Box sx={{ width: '100%', ml: { xs: 0, md: 2 } }}></Box>}
          <LogoMain width={250}/>
        {!downLG && <Box sx={{ width: '100%', ml: { xs: 0, md: 2 } }}></Box>}
      {/* {!downLG && megaMenu} */}
      {/* {!downLG && localization} */}
     
      
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}
       {isUpdateAvailable && <Button variant="contained" color="primary" size='large' sx={{width:700,marginRight:10,backgroundColor:'#FF2C2C','&:hover': {backgroundColor: '#d32f2f',},}} startIcon={<RefreshCircle />} onClick={() => {
        localStorage.setItem('local_version', webVersion??'0');
        window.location.reload();
        }}>
            Update & Refresh
          </Button>}
       {/* <IconButton  title='Update' size="medium" aria-label="close" color="primary" onClick={() => { window.open('http://92.205.229.45/apps/nl.apk', '_blank') }} sx={{ bgcolor: 'secondary.200', p: 1 }}>
      </IconButton> */}

      <IconButton size="medium" aria-label="close" color="primary" onClick={() => { window.open('http://92.205.229.45/apps/nl.apk', '_blank') }} sx={{ bgcolor: 'secondary.200', p: 1,display:'none' }}>
        <Apple />
      </IconButton>
      {/*<IconButton size="medium" aria-label="close" color="primary" onClick={() => { window.open('https://newlooksystem.com/apps/nl.apk', '_blank') }} sx={{ bgcolor: 'secondary.200', p: 1 }}>
        <Android />
      </IconButton> */}
      <Notification />
      {(1==1)? <></>:
        <>
            <Message  />
        </>
       }
      
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
};

export default HeaderContent;
